import {
  combineActions,
  handleActions,
} from 'redux-actions';
import update from 'immutability-helper';

import FPPActionCreators from '../actions/FPPActionCreators';

const {
  getFppRecordListRequest,
  getFppRecordListSuccess,
  getFppRecordListFailure,
  getFppMainQuestionsRequest,
  getFppMainQuestionsSuccess,
  getFppMainQuestionsFailure,
  getFppRecommendationRequest,
  getFppRecommendationSuccess,
  getFppRecommendationFailure,
  checkExportPdfPermissionRequest,
  checkExportPdfPermissionSuccess,
  checkExportPdfPermissionFailure,
} = FPPActionCreators;

const initialState = {
  isLoading: false,
  error: null,
  assessments: [],
};

export default handleActions({
  [combineActions(
    getFppRecordListRequest,
    getFppMainQuestionsRequest,
    getFppRecommendationRequest,
    checkExportPdfPermissionRequest,
  )]: state => update(state, {
    isLoading: { $set: true },
    error: { $set: initialState.error },
  }),
  [combineActions(
    getFppMainQuestionsSuccess,
    getFppRecommendationSuccess,
    checkExportPdfPermissionSuccess,
  )]: state => update(state, {
    isLoading: { $set: false },
  }),
  [getFppRecordListSuccess]: (state, { payload }) => update(state, {
    isLoading: { $set: false },
    assessments: { $set: payload },
  }),
  [combineActions(
    getFppRecordListFailure,
    getFppMainQuestionsFailure,
    getFppRecommendationFailure,
    checkExportPdfPermissionFailure,
  )]: (state, { payload }) => update(state, {
    isLoading: { $set: false },
    error: { $set: payload.error },
  }),
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/fpp.js